import React, { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { ErrorReason, ErrorStatus } from '@tink/core/src/tinkLinkErrorCodes';
import { AppState } from '../../../../stores/redux-store';
import { LoadingOverlay } from '../../../screens/LoadingOverlay/LoadingOverlay';
import { fetchProvider as fetchProviderConnect } from '../../../../services/providers';
import { fetchUserCredentials as fetchUserCredentialsConnect } from '../../../../connectivity/services/credentials';
import { applicationParameters } from '../../../../utilities/application-parameters';
import { getCredentials as getCredentialsImport } from '../../../../lib-api/services/Credentials';

export type CredentialsFinderUpdateConsentOwnProps = {
  children: React.ReactNode;
};

type CredentialsFinderUpdateConsentProps = CredentialsFinderUpdateConsentOwnProps &
  PropsFromRedux & {
    credentialsId?: string | undefined;
    getCredentials?: typeof getCredentialsImport;
  };

export const credentialsFindError = {
  errorStatus: ErrorStatus.INTERNAL_ERROR,
  errorReason: ErrorReason.REQUEST_FAILED_FETCH_CREDENTIALS,
};

export const CredentialsFinderUpdateConsentPresenter: React.FC<
  CredentialsFinderUpdateConsentProps
> = ({
  children,
  providers,
  userCredentials,
  fetchProvider,
  credentialsId = applicationParameters.get('credentialsId'),
  fetchUserCredentials,
}) => {
  const credentials = userCredentials.find((c) => c.id === credentialsId);

  useEffect(() => {
    if (credentialsId && !credentials) {
      fetchUserCredentials({ credentialsId });
    }
  }, [credentials, credentialsId, fetchUserCredentials]);

  useEffect(() => {
    if (credentials?.id && !providers) {
      fetchProvider(credentials.providerName);
    }
  }, [credentials?.id, credentials?.providerName, fetchProvider, providers]);

  const providerLoading = !providers;
  const credentialsLoading = credentialsId && !credentials;

  if (providerLoading || credentialsLoading) {
    return <LoadingOverlay />;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

const mapStateToProps = (state: AppState) => {
  return {
    providers: state.providers.data,
    userCredentials: state.userCredentials.data,
  };
};

const mapDispatchToState = {
  fetchProvider: fetchProviderConnect,
  fetchUserCredentials: fetchUserCredentialsConnect,
};
const connector = connect(mapStateToProps, mapDispatchToState);

type PropsFromRedux = ConnectedProps<typeof connector>;

export const CredentialsFinderUpdateConsent = connector(CredentialsFinderUpdateConsentPresenter);
